export const stringHasValue = (str: string | null | undefined): str is string => {
  return str !== null && str !== undefined && str !== '';
};
